import { accentColors, lighterVariations } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${lighterVariations.blue.darker};

  p {
    margin-left: 1rem;
    padding: 1.6rem 0;
    color: ${({ theme }) => theme.colors.grey[100]};
  }

  > svg {
    color: ${accentColors.info.dark};
    height: 1.6rem;
    width: 1.6rem;
  }
`;

export const StyledCloseBtn = styled.button`
  position: absolute;
  right: 2.6rem;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.grey[500]};

  svg {
    height: 1.8rem;
    width: 1.8rem;
  }
`;
